export const EXCEL_CONFIG = {
    WORKSHEET_NAME: "Kilometers",
    THUISWERK_WORKSHEET_NAME: "Dagen",
    CELLS_TO_PAINT: [
        "B9",
        "C9",
        "D9",
        "E9",
        "F9",
        "B7",
        "C7",
        "B3",
        "C3",
        "B2",
        "C2",
        "F10",
        "B62",
        "C62",
        "D62",
        "E62",
        "F62",
        "B63",
        "C63",
        "B64",
        "C64",
        "D64",
        "E64",
        "F64",
        "B65",
        "C65",
        "B66",
        "C66",
        "D66",
        "E66",
        "F66",
        "B67",
        "C67",
        "B68",
        "C68",
        "D68",
        "E68",
        "F68",
    ],
    CELL_MAPPINGS: {
        NAME: "C4",
        CITY: "C5",
        MONTH: "C6",
        START_ROW: 11,
    },
    STYLING: {
        PRIMARY_FILL: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "0xFF0047FF" },
        },
        WHITE_FONT: {
            color: { argb: "FFFFFFFF" },
        },
    },
};

export const FILE_NAMES = {
    REISKOSTEN_TEMPLATE: "template_impres.xlsx",
    THUISWERK_TEMPLATE: "work-from-home_impres.xlsx",
};
